import { exists } from '../tools/exists';
import { docReady, importLoader } from '../tools/events';

docReady(function () {
    // Add your js module file imports here
    if (
        exists('[data-behaviour="image-carousel"]') ||
        exists('[data-behaviour="testimonial-slider"]') ||
        exists('[data-behaviour="hotpodhome-slider"]') ||
        exists('[data-behaviour="team-slider"]') ||
        exists('[data-behaviour="studio-slider"]') ||
        exists('[data-behaviour="owner-slider"]')
    ) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./slider');
            });
        });
    }

    if (exists('[data-behaviour="change-filter"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./filter');
            });
        });
    }

    if (exists('[data-behaviour="menu-toggle"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./menu');
            });
        });
    }

    if (exists('[data-behaviour="faq"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./faq');
            });
        });
    }

    // Gate on the modal, not the trigger: the timetable's instructor triggers are
    // rendered by React after this runs, whereas the modals ship in the HTML.
    if (exists('[data-behaviour="team-bio-modal"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./team-bio');
            });
        });
    }

    // Gate on the modal rather than the link: Gravity Forms renders both, but the
    // form is embedded with ajax=true, so only the modal is guaranteed to still
    // be the element that was here when this ran.
    if (exists('[data-behaviour="waiver-modal"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./waiver-modal');
            });
        });
    }

    if (exists('[data-behaviour="tabs"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./tabs');
            });
        });
    }

    if (exists('[data-behaviour="video-embed"]')) {
        import('./video-embed');
    }

    if (exists('[data-behaviour="add-to-calendar"]')) {
        import('./add-to-calendar');
    }

    // Not deferred: the header button is above the fold, so correct it as soon
    // as possible
    if (exists('.button--studio-find .button__studio-name')) {
        import('./studio-link');
    }
    
    if (exists('[data-behaviour="video-banner"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./video-banner');
            });
        });
    }

    if (exists('[data-behaviour="swap-links-logged-in"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./links');
            });
        });
    }

    if (exists('[data-behaviour="video-embed"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./video-embed');
            });
        });
    }

    if (exists('[data-behaviour="app-link"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./app-link');
            });
        });
    }

    if (exists('[data-behaviour="video"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./video');
            });
        });
    }

    if (exists('[data-behaviour="courses"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./courses');
                import('./modals');
            });
        });
    }

    if (exists('[data-behaviour="page-tabs"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./page-tabs');
            });
        });
    }

    if (exists('[data-behaviour="stacked-content"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./stacked-content');
            });
        });
    }

    if (exists('[data-behaviour="studio-nav"]')) {
        window.requestAnimationFrame(function () {
            setTimeout(function () {
                import('./studio-nav');
                import('./studio-tabs');
            });
        });
    }

});
